module.exports = __webpack_public_path__ + "media/customizations/riverstone/back-7bb5c27ad55d6334dfbca2a87ea5fab3.jpg";